import StartNode from "./startNode";
import MessageNode from "./messageNode";
import SingleBlockNode from "./singleBlockNode";
import MenuNode from "./menuNode";
import ButtonNode from "./buttonNode";
import ButtonPixNode from "./buttonPixNode";
import ListNode from "./listNode";
import InputNode from "./inputNode";
import IntervalNode from "./intervalNode";
import ConditionNode from "./conditionNode";
import RandomizerNode from "./randomizerNode";
import TicketNode from "./ticketNode";
import TagNode from "./tagNode";
import RemoveTagNode from "./removeTagNode";
import SwitchFlowNode from "./switchFlowNode";
import AttendantNode from "./attendantNode";
import CampaignProNode from "./campaignProNode";
import HttpRequestNode from "./httpRequestNode";
import VariableNode from "./variableNode";
import OpenaiNode from "./openaiNode";
import GeminiNode from "./geminiNode";
import ImgNode from "./imgNode";
import AudioNode from "./audioNode";
import VideoNode from "./videoNode";
import IfAdvancedNode from "./ifAdvancedNode";
import SwitchNode from "./switchNode";
import FilterNode from "./filterNode";
import WaitNode from "./waitNode";
import StickyNoteNode from "./stickyNoteNode";
import GroupNode from "./groupNode";
import CodeNode from "./codeNode";
import MergeNode from "./mergeNode";
import SetAdvancedNode from "./setAdvancedNode";
import WebhookTriggerNode from "./webhookTriggerNode";
import ScheduleTriggerNode from "./scheduleTriggerNode";
import SendTemplateNode from "./sendTemplateNode";
import SendLocationNode from "./sendLocationNode";
import SendContactNode from "./sendContactNode";
import SendStickerNode from "./sendStickerNode";
import SendReactionNode from "./sendReactionNode";
import LoopNode from "./loopNode";
import SplitBatchNode from "./splitBatchNode";
import DateTimeNode from "./dateTimeNode";
import TextNode from "./textNode";
import RegexNode from "./regexNode";
import AIAgentNode from "./aiAgentNode";
import TextClassifierNode from "./textClassifierNode";
import StopErrorNode from "./stopErrorNode";
import ErrorTriggerNode from "./errorTriggerNode";
import EmailSmtpNode from "./emailSmtpNode";
import IxcBuscarClienteNode from "./ixcBuscarClienteNode";
import IxcBuscarFaturaNode from "./ixcBuscarFaturaNode";
import IxcDesbloquearNode from "./ixcDesbloquearNode";
import BusinessHoursNode from "./businessHoursNode";
import TagCheckNode from "./tagCheckNode";

/**
 * Mapa de tipos de node para seus componentes React.
 * A chave deve coincidir com node.type salvo no banco.
 */
export const nodeTypes = {
  start: StartNode,
  message: MessageNode,
  singleBlock: SingleBlockNode,
  menu: MenuNode,
  button: ButtonNode,
  buttonPix: ButtonPixNode,
  list: ListNode,
  input: InputNode,
  interval: IntervalNode,
  condition: ConditionNode,
  randomizer: RandomizerNode,
  ticket: TicketNode,
  tag: TagNode,
  removeTag: RemoveTagNode,
  switchFlow: SwitchFlowNode,
  attendant: AttendantNode,
  campaignPro: CampaignProNode,
  httpRequest: HttpRequestNode,
  variable: VariableNode,
  openai: OpenaiNode,
  gemini: GeminiNode,
  img: ImgNode,
  audio: AudioNode,
  video: VideoNode,
  ifAdvanced: IfAdvancedNode,
  switch: SwitchNode,
  filter: FilterNode,
  wait: WaitNode,
  stickyNote: StickyNoteNode,
  group: GroupNode,
  code: CodeNode,
  merge: MergeNode,
  setAdvanced: SetAdvancedNode,
  webhookTrigger: WebhookTriggerNode,
  scheduleTrigger: ScheduleTriggerNode,
  sendTemplate: SendTemplateNode,
  sendLocation: SendLocationNode,
  sendContact: SendContactNode,
  sendSticker: SendStickerNode,
  sendReaction: SendReactionNode,
  loop: LoopNode,
  splitBatch: SplitBatchNode,
  dateTime: DateTimeNode,
  text: TextNode,
  regex: RegexNode,
  aiAgent: AIAgentNode,
  textClassifier: TextClassifierNode,
  stopError: StopErrorNode,
  errorTrigger: ErrorTriggerNode,
  emailSmtp: EmailSmtpNode,
  ixcBuscarCliente: IxcBuscarClienteNode,
  ixcBuscarFatura: IxcBuscarFaturaNode,
  ixcDesbloquear: IxcDesbloquearNode,
  businessHours: BusinessHoursNode,
  tagCheck: TagCheckNode,
};

/**
 * Categorias para a paleta lateral do FlowBuilder.
 * Cada categoria agrupa tipos de nodes para facilitar a selecao.
 */
export const NODE_CATEGORIES = [
  {
    label: "Inicio",
    color: "#3aba38",
    nodes: [
      { type: "start", label: "Inicio", icon: "RocketLaunch" },
      { type: "webhookTrigger", label: "Webhook", icon: "Webhook" },
      { type: "scheduleTrigger", label: "Agendamento", icon: "Schedule" },
      { type: "errorTrigger", label: "Trigger de Erro", icon: "ErrorOutline" },
    ],
  },
  {
    label: "Mensagens",
    color: "#555",
    nodes: [
      { type: "message", label: "Mensagem", icon: "Message" },
      { type: "singleBlock", label: "Conteudo", icon: "LibraryBooks" },
      { type: "img", label: "Imagem", icon: "Image" },
      { type: "audio", label: "Audio", icon: "MicNone" },
      { type: "video", label: "Video", icon: "Videocam" },
      { type: "sendTemplate", label: "Template HSM", icon: "Description" },
      { type: "sendLocation", label: "Localizacao", icon: "LocationOn" },
      { type: "sendContact", label: "Contato (vCard)", icon: "ContactPhone" },
      { type: "sendSticker", label: "Sticker", icon: "EmojiEmotions" },
      { type: "sendReaction", label: "Reacao", icon: "ThumbUp" },
    ],
  },
  {
    label: "Interacao",
    color: "#683AC8",
    nodes: [
      { type: "menu", label: "Menu", icon: "DynamicFeed" },
      { type: "button", label: "Botoes", icon: "SmartButton" },
      { type: "buttonPix", label: "Botao PIX", icon: "Pix" },
      { type: "list", label: "Lista", icon: "ViewList" },
      { type: "input", label: "Captura de Entrada", icon: "TextFields" },
    ],
  },
  {
    label: "Logica",
    color: "#F57C00",
    nodes: [
      { type: "condition", label: "Condicao", icon: "ImportExport" },
      { type: "ifAdvanced", label: "IF Avancado", icon: "AccountTree" },
      { type: "switch", label: "Switch", icon: "AltRoute" },
      { type: "filter", label: "Filtro", icon: "FilterAlt" },
      { type: "randomizer", label: "Randomizador", icon: "Casino" },
      { type: "interval", label: "Intervalo", icon: "AccessTime" },
      { type: "wait", label: "Aguardar", icon: "HourglassEmpty" },
      { type: "merge", label: "Unir Caminhos", icon: "CallMerge" },
      { type: "loop", label: "Loop", icon: "Loop" },
      { type: "splitBatch", label: "Lotes", icon: "ViewStream" },
      { type: "stopError", label: "Parar com Erro", icon: "Cancel" },
      { type: "switchFlow", label: "Trocar Fluxo", icon: "AccountTree" },
      { type: "businessHours", label: "Horario Atendimento", icon: "AccessTime" },
      { type: "tagCheck", label: "Verificar Tag", icon: "LocalOffer" },
    ],
  },
  {
    label: "Acoes",
    color: "#1565C0",
    nodes: [
      { type: "ticket", label: "Transferir Fila", icon: "ConfirmationNumber" },
      { type: "tag", label: "Adicionar Tag", icon: "Label" },
      { type: "removeTag", label: "Remover Tag", icon: "LabelOff" },
      { type: "attendant", label: "Atendente", icon: "SupportAgent" },
      { type: "campaignPro", label: "Campanha Pro", icon: "Campaign" },
    ],
  },
  {
    label: "Integracao",
    color: "#0277BD",
    nodes: [
      { type: "httpRequest", label: "Requisicao HTTP", icon: "Http" },
      { type: "variable", label: "Variavel", icon: "DataObject" },
      { type: "setAdvanced", label: "Set Avancado", icon: "Transform" },
      { type: "code", label: "Codigo JS", icon: "Code" },
      { type: "dateTime", label: "Data/Hora", icon: "AccessTime" },
      { type: "text", label: "Texto", icon: "TextFields" },
      { type: "regex", label: "Regex", icon: "FindReplace" },
      { type: "emailSmtp", label: "Email SMTP", icon: "Email" },
    ],
  },
  {
    label: "Inteligencia Artificial",
    color: "#10A37F",
    nodes: [
      { type: "openai", label: "OpenAI", icon: "Psychology" },
      { type: "gemini", label: "Gemini", icon: "AutoAwesome" },
      { type: "aiAgent", label: "Agente IA", icon: "SmartToy" },
      { type: "textClassifier", label: "Classificador", icon: "Category" },
    ],
  },
  {
    label: "Documentacao",
    color: "#F9A825",
    nodes: [
      { type: "stickyNote", label: "Nota Adesiva", icon: "StickyNote2" },
      { type: "group", label: "Grupo", icon: "Workspaces" },
    ],
  },
  {
    label: "IXC Provedor",
    color: "#0D47A1",
    nodes: [
      { type: "ixcBuscarCliente", label: "Buscar Cliente", icon: "PersonSearch" },
      { type: "ixcBuscarFatura", label: "Buscar Fatura", icon: "Receipt" },
      { type: "ixcDesbloquear", label: "Desbloquear", icon: "LockOpen" },
    ],
  },
];

export default nodeTypes;
